/* @flow */
/* eslint-disable */
import React, { Component } from 'react';
import { reduxConnect } from '../../../../hoc';
import * as actions from '../../../../containers/Alerts/AlertTypes/actions.landmarks';
import StopAlert from '../../../../components/Alerts/AlertTypes/Stop/StopAlert';

type Props = {
    landmarkGroups: Array<{}>,
    landmarkList: Array<{}>,
    fetchAlertCreationLandmarkGroupsList: Function,
    fetchLandmarkList: Function,
    formData:{
        config:{
            speedThresholdMPH: Number,
            selectedLandmarkGroups: Array<{}>,
            selectedLandmarkFilters: Array<{}>,
        },
    },
    handleTextboxChange: Function,
    handleCheckboxChange: Function,
    clearLandmarkSelects: Function,
    isLoading: boolean,
    validationError?: String,
};

type State = {
    allLandmarkGroups: Array<{}>,
    selectedLandmarkGroups: Array<{}>,
    selectedLandmarkFilters: Array<{}>,
};

class StopAlertList extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            allLandmarkGroups: [],
            selectedLandmarkGroups: this.props.formData.config.selectedLandmarkGroups,
            selectedLandmarkFilters: this.props.formData.config.selectedLandmarkFilters,
        };
    }

    componentDidMount() {
        this.props.fetchAlertCreationLandmarkGroupsList();
        const selectedLandmarkGroups = {
            selectedLandmarkGroups: this.props.formData.config.selectedLandmarkGroups ?
                this.props.formData.config.selectedLandmarkGroups : [],
        };
        this.setState(selectedLandmarkGroups);
    }

    componentDidUpdate(prevProps) {
        const { landmarkGroups } = this.props;
        if (landmarkGroups && landmarkGroups.length > 0 &&
            prevProps.landmarkGroups !== landmarkGroups &&
            this.state.allLandmarkGroups !== landmarkGroups) {
            this.setState({
                allLandmarkGroups: landmarkGroups,
            });
        }
    }
    // fetching landmarks from landmark-groups
    fetchLandmarksFromGroups = (landmarkGroupsList) => {
        const selectedLandmarkGroups = { selectedLandmarkGroups: [] };
        if (landmarkGroupsList.length > 0) {
            selectedLandmarkGroups.selectedLandmarkGroups = landmarkGroupsList;
        } else {
            selectedLandmarkGroups.selectedLandmarkGroups = [];
        }
    }

    render() {
        return (
            <StopAlert
                formData={this.props.formData}
                handleTextboxChange={this.props.handleTextboxChange}
                validationError={this.props.validationError}
                handleCheckboxChange={this.props.handleCheckboxChange}
                clearLandmarkSelects={this.props.clearLandmarkSelects}
                allLandmarkGroups={this.state.allLandmarkGroups}
            />
        );
    }
}

const mapStateToProps = state => ({
    landmarkGroups: state.alertLandmarks.landmarkGroups,
    isLoading: state.alertLandmarks.isLoading,
});

export default reduxConnect(StopAlertList, actions, mapStateToProps);